// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { compose, withHandlers, withProps } from 'recompose';
import { getOr, curry } from 'lodash/fp';

/**
 * Change metric handler
 * @param {Object} props
 * @param {Object} value
 * @param {Object} element
 */
function onChange({ reportPart }, { value }, element: any) {
  const reportPartContent = reportPart.reportPartContent || {};
  reportPartContent.setActiveSerie(value, element);
}

/**
 * Update drill handler
 */
function updateDrillComponent(): void {
  const reportPart = getOr({}, 'reportPart', this.props);
  reportPart.onDrilldown = this.props.onDrilldown;
}

/**
 * Drill handler
 * @param {Object} props
 * @param {Object} drilldownValue
 * @param {Object} separatorValue
 */
function onDrilldown(props: any, drilldownValue: any, separatorValue: any): void {
  const {
    reportPart,
    printingMode,
    reportPart: { reportPartContent }
  } = props;

  const canDrilldown = reportPartContent.updateDrilldownInfo(drilldownValue, separatorValue);

  if (canDrilldown) {
    !!props.publishDrillInfo &&
      props.publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());
    const loadingProcess = props
      .needUpdatePreview(reportPart, reportPartContent.getDrilldownInfo(), null, null, printingMode)
      .then(() => {
        reportPartContent.isCrossFiltering &&
          props.store &&
          props.store.loadReportPartDataByCrossFiltering(reportPart.id);
      });
    props.showLoading && props.showLoading(loadingProcess);
  }
}

/**
 * Update page size
 * @param {Object} props
 * @param {Object} pageSize
 */
function setPageSize(props: any, pageSize: any): void {
  return props.reportPart.reportPartContent.setPageSize(pageSize);
}

export default compose(
  withProps({
    updateDrillComponent: updateDrillComponent
  }),
  withHandlers({
    onChange: curry(onChange),
    onDrilldown: curry(onDrilldown),
    setPageSize: curry(setPageSize)
  })
);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.GaugeFrontSideActions.js